export type { ChallengeSrcOptions } from '../shared/getChallengeSrc';
export { getChallengeSrc } from '../shared/getChallengeSrc';

export const CHALLENGE_PATHNAME = '/challenge/v4/html';
